import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormatDateTzPipe } from './format-date-tz.pipe';
import { CurrencyFormatPipe } from './currency-format.pipe';
import { FormatDateLocalPipe } from './format-date-local.pipe';

@NgModule({
  declarations: [FormatDateTzPipe, CurrencyFormatPipe, FormatDateLocalPipe],
  imports: [CommonModule],
  exports: [FormatDateTzPipe, CurrencyFormatPipe, FormatDateLocalPipe],
})
export class PipesModule {}
